// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";
import { css } from "styled-components";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductIconBadge, { ProductIconBadgeStyles } from "@store/Library/Components/ProductIconBadge";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import constants from "@store/constants";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsIconBadgeStyles {
    container?: InjectableCss;
    productIconBadge?: ProductIconBadgeStyles;
}

export const productDetailsIconBadgeStyles: ProductDetailsIconBadgeStyles = {
    container: {
        css: css`
            ${spacingStyles(null, pxToRem(12))}
        `,
    },
    productIconBadge: {
        wrapper: {
            css: css`
                width: ${pxToRem(44)};
            `,
        },
    },
};

const styles = productDetailsIconBadgeStyles;

const ProductDetailsIconBadge: React.FC<Props> = ({ product }) => {
    const iconBadgeProperty = constants.productAttributes.iconBadgeGauge;
    const productIconBadge = product.properties[iconBadgeProperty];

    if (!productIconBadge || productIconBadge.trim() === "") {
        return null;
    }

    return (
        <StyledWrapper {...styles.container}>
            <ProductIconBadge src={productIconBadge} extendedStyles={styles.productIconBadge} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsIconBadge),
    definition: {
        displayName: "Product Icon Badge",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
